import { useState, useEffect, useMemo } from 'react';
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { set } from 'd3v4';

export default function WorkflowRun() {
    const navigate = useNavigate();
    const location = useLocation();
    const [success, setSuccess] = useState(false);

    const [workflowName, setWorkflowName] = useState('');
    const [aggregateError, setAggregateError] = useState({visible: false, messages: []});

    const [definitions, setDefinitions] = useState([]);
    const defMap = {};
    definitions.forEach(def => {
        defMap[def.id] = def;
    });

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    }
    

    const [selectedDefinition, setSelectedDefinition] = useState(null);
    if (definitions.length && location.state && selectedDefinition === null) {
        setSelectedDefinition(defMap[location.state.definition]);
    }
    
    // const [groups, setGroups] = useState(['R3JvdXBOb2RlOjM0'])
    const groups = JSON.parse(getSessionStorageOrDefault('usergroups', '[]'));
    const [datasets, setDatasets] = useState([]);

    // Selected Dataset
    const [selectedDataset, setSelectedDataset] = useState(null);
    
    useEffect(() => {
        // If the location state has a dataset and the selectedDataset is null, set the selectedDataset to the dataset in the location state
        if (datasets.length && location.state && selectedDataset === null) {

            const dsid = location.state.dataSet ? location.state.dataSet.id : null;
            if (!dsid) return;
            setSelectedDataset(datasets.find(ds => ds.id === dsid));
        }
    }, [datasets, selectedDataset])
 
    const [configKeys, setConfigKeys] = useState([]);
    const [workflowConfigValues, setWorkflowConfigValues] = useState({});

    // const [executionEnvironment, setExecutionEnvironment] = useState(null);
    // const environments = [
    //     {
    //         name: 'conda'
    //     },
    //     {
    //         name: 'singularity'
    //     }
    // ];
    const [visible1, setVisible1] = useState(false);

    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));


    const headers = useMemo(() => { 
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getDataUserToken}`,
        };
    }, [getDataUserToken]);

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/definition?userId=${userid}`, {
            headers,
        })
            .then((res) => res.json())
            .then((data) => setDefinitions(data))
    },[headers, userid]);

    useEffect(() => {
        setWorkflowConfigValues({});
        if (!selectedDefinition) {
            if (configKeys.length) setConfigKeys([]);
            return;
        }
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/definition/${selectedDefinition.id}?userId=${userid}`, {
            headers,
        })
            .then(res => res.json())
            .then(def => setConfigKeys(def.ConfigKeys.sort((a, b) => a.order - b.order) || []))
    }, [selectedDefinition, configKeys.length, headers, userid]);

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/dataset?userId=${userid}`, {
            headers,
        })
            .then((res) => res.json())
            .then((data) => setDatasets(data))
    },[headers, userid]);

    const successNavHome = () => navigate('/', {state: {workflowSuccess: true}});

    const testAggregate = async () => {
        const res = await fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/aggregatedataset/' + selectedDataset.id, {
            headers,
            method: 'POST'
        })
        const data = await res.json()
        if (res.ok) {
            console.log('aggregate data success', data);
            setVisible1(true);
        } else {
            setAggregateError({visible: true, messages: data.message});
            console.log('aggregate data error', data);
        }
    }

    const executeWorkflow = () => {
        console.log('executing workflow');
        const form = new FormData();
        form.append('name', workflowName);
        form.append('ownerId', userid);
        form.append('groupId', JSON.stringify(groups));
        form.append('definitinId', selectedDefinition.id);
        form.append('dataId', selectedDataset.id);
        form.append('executionEnvironment', 'singularity');
        // form.append()

        let aggregate_error = false;
        let aggregate_complete = false;

        // aggregate dataset
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/aggregatedataset/' + selectedDataset.id, {
            headers,
            method: 'POST'
        })
        .then( res => {
            if ( res.ok ) aggregate_complete = true;
            else throw new Error( res );
        })
        // .then(confirmation => {
        //     console.log('confirmation', confirmation)
        // })
        // .catch(err => { 
        //     aggregate_error = true;
        //     // throw err;
        //     return console.error(err);
        // });

        .then(() => { 

            if (aggregate_complete) {

                // create workflow
                fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/workflow', {
                    headers: {
                        Authorization: `Bearer ${getDataUserToken}`,
                    },
                    method: 'POST',
                    body: form
                }).then(
                    res => res.json()
                ).then(wf => {
                    if (Object.keys(workflowConfigValues).length) {
                        console.log('configuring workflow');
                        return Promise.all(Object.entries(workflowConfigValues).map(([key, value]) => {
                            const configForm = new FormData();
                            configForm.append('workflowId', wf.id);
                            configForm.append('key', key);
                            configForm.append('value', value);
                            return fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/workflowconfiguration', {
                                headers: {
                                    Authorization: `Bearer ${getDataUserToken}`,
                                },
                                method: 'POST',
                                body: configForm
                            }).then(res => res.json());
                        }))
                    } else {
                        return [{workflowId: wf.id}]
                    }
                })
                .then(configs => fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/executeWorkflow/' + configs[0].workflowId, {
                    headers: {
                        Authorization: `Bearer ${getDataUserToken}`,
                    },
                    method: 'POST',
                    body: form
                })
                .then(res => res.json())
                .then(conf => {
                    console.log(conf);
                    // setSuccess(true);
                    successNavHome();
                })
                ).catch(err => console.error(err));
            }
        })
    }

    const configInputs = [];
    const configConfirms = [];


    configKeys.forEach(configKey => {
        const {ConfigValues, DisplayKey, id, key} = configKey;   // eslint-disable-line no-unused-vars

        if (!ConfigValues.length) return;

        if (configKey.control_type === 'HIDDEN') return;

        // let key = '';

        // if (key_temp) {
        //     const key = key_temp.replace(/ /g, '_').toLowerCase();
        // } 

        // key = key_temp;

        console.log('configKey', configKey);

        // If ConfigKey has a default value, set it in the workflowConfigValues and set the default_value to false
        configKey.ConfigValues.forEach(configValue => {
            if (configValue.default_value) {
                if (configKey.value_type === 'BOOLEAN') {
                    workflowConfigValues[key] = configValue.value === 'true';
                } 
                else if (configKey.value_type === 'MULTI_CHOICE') {
                    if (!workflowConfigValues[key]) workflowConfigValues[key] = [];
                    workflowConfigValues[key].push(configValue.DisplayValue);
                } else if (configKey.value_type === 'INTEGER_RANGE') {
                    const { startVal, stopVal, stepVal } = JSON.parse(configValue.value);
                    workflowConfigValues[key] = Number(stopVal);
                } else {
                    workflowConfigValues[key] = configValue.value;
                }

                configValue.default_value = false;
            }
        });

        console.log('workflowConfigValues', workflowConfigValues);
        console.log('key', key);
        // console.log('key_temp', key_temp);
        // console.log('configKey', configKey);
        // console.log('workflowConfigValues[key]', workflowConfigValues[key]);

        if (configKey.value_type === 'BOOLEAN') {
            configInputs.push(
                <div className="flex flex-wrap justify-content-center gap-3 mb-4">
                    <span className="ml-2 mb-4">{configKey.DisplayKey}</span>
                    <div className="flex align-items-center">
                        <Checkbox inputId={'configKey' + key} 
                            name={key} 
                            // value={key}
                            value={key}
                            onChange={(e) => {
                                const newWfConfigValues = {...workflowConfigValues};
                                newWfConfigValues[key] = e.checked;
                                setWorkflowConfigValues(newWfConfigValues);
                            }} 
                            checked={workflowConfigValues[key] || false}
                        />
                        {/* <label htmlFor={'configKey' + key} className="ml-2">True</label> */}
                    </div>
                </div>
            )
        } else if (configKey.value_type === 'MULTI_CHOICE') {
            configInputs.push(
                <div className="field mb-4 col-12 md:col-6">
                    <div className="flex flex-wrap justify-content-start gap-3">
                        <span className="ml-2 mb-4">{configKey.DisplayKey}</span>

                        {configKey.ConfigValues.map((value) => {
                            return (
                                <div className="flex align-items-center">
                                <Checkbox inputId={'configKey' + key} 
                                    name={value.value} 
                                    value={value.DisplayValue}
                                    onChange={(e) => {

                                        const newWfConfigValues = {...workflowConfigValues};

                                        if (!e.value) delete newWfConfigValues[key];
                                        else {
                                            if (!newWfConfigValues[key]) newWfConfigValues[key] = [];

                                            if (newWfConfigValues[key].includes(e.value)) {
                                                newWfConfigValues[key] = newWfConfigValues[key].filter(val => val !== e.value);
                                            } else {
                                                newWfConfigValues[key].push(e.value);
                                            }

                                            if (!newWfConfigValues[key].length) delete newWfConfigValues[key];

                                        }

                                        setWorkflowConfigValues(newWfConfigValues);

                                    }} 

                                    checked={workflowConfigValues[key] && workflowConfigValues[key].includes(value.DisplayValue) || false}
                                />
                                    <label htmlFor={'configKey' + key} className="ml-2">{value.DisplayValue}</label>
                                </div>
                            )
                        })}

                    </div>
                </div>
            )
        } else if (configKey.value_type === 'INTEGER_RANGE') {
            // Unwind the Range , show users a dropdown to select one of the values.
            const { startVal, stopVal, stepVal } = JSON.parse(ConfigValues[0].value);

            const range = [];
            for (let i = Number(startVal); i <= Number(stopVal); i += Number(stepVal)) {
                range.push(i);
            }

            configInputs.push(

                <>
                <div className="field mb-4 col-12 md:col-6">
            
                    <label htmlFor={'configKey' + key} className="font-medium text-900">{DisplayKey || key}</label>
                    <Dropdown inputId={'configKey' + key}
                        options={range} 
                        value={workflowConfigValues[key]}
                        onChange={(e) => {
                            const newWfConfigValues = {...workflowConfigValues};
                            if (!e.value) delete newWfConfigValues[key];
                            else newWfConfigValues[key] = e.value;
                            setWorkflowConfigValues(newWfConfigValues);
                        }} 
                        // optionLabel="value" 
                        // filter filterBy="DisplayValue" showClear
                        placeholder="Select a Value" 
                        itemTemplate={(value) => <div className="flex align-items-center">
                            <div>{value}</div>
                        </div>} />
                </div>


                    {/* <div className="field mb-4 col-12">

                        <label className="font-medium text-900">{DisplayKey || key}</label>

                        <div className="card flex align-items-center md:flex-row gap-3 flex-wrap align-content-center justify-content-center">
                        
                            <div className="p-inputgroup flex-1 w-3 ">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-play"></i>
                                </span>
                                <InputText id={'configKey' + key} type="number" value={workflowConfigValues[key]} onChange={(e) => {
                                    const newWfConfigValues = {...workflowConfigValues};
                                    newWfConfigValues[key].start = e.target.value;
                                    setWorkflowConfigValues(newWfConfigValues);
                                    }}
                                    placeholder="Start"
                                    style={{ width: '50%' }}
                                />
                            </div>

                            <div className="p-inputgroup flex-1 w-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-stop"></i>
                                </span>
                                <InputText id={'configKey' + key} type="number" value={workflowConfigValues[key]} onChange={(e) => {
                                    const newWfConfigValues = {...workflowConfigValues};
                                    newWfConfigValues[key].end = e.target.value;
                                    setWorkflowConfigValues(newWfConfigValues);
                                    }} 
                                    placeholder="Stop"
                                    style={{ width: '50%' }}
                                />
                            </div>

                            <div className="p-inputgroup flex-1 w-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-step-forward"></i>
                                </span>
                                <InputText id={'configKey' + key} type="number" value={workflowConfigValues[key]} onChange={(e) => {
                                    const newWfConfigValues = {...workflowConfigValues};
                                    newWfConfigValues[key].step = e.target.value;
                                    setWorkflowConfigValues(newWfConfigValues);
                                    }} 
                                    placeholder="Step"
                                    style={{ width: '50%' }}
                                />
                            </div>
                        </div>

                    </div> */}
                    </>
            )
        } else { 
            // If the configKey.control_type is not 'BOOLEAN' or 'MULTI_CHOICE', or 'INTEGER_RANGE', it has to be 'SINGLE_CHOICE' so add a Dropdown to the configInputs
            configInputs.push(
                <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor={'configKey' + key} className="font-medium text-900">{DisplayKey || key}</label>
                    <Dropdown inputId={'configKey' + key}
                        options={ConfigValues} 
                        value={workflowConfigValues[key]}
                        onChange={(e) => {
                            const newWfConfigValues = {...workflowConfigValues};
                            if (!e.value) delete newWfConfigValues[key];
                            else newWfConfigValues[key] = e.value;
                            setWorkflowConfigValues(newWfConfigValues);
                        }} 
                        optionLabel="DisplayValue" 
                        filter filterBy="DisplayValue" showClear 
                        placeholder="Select a Value" 
                        itemTemplate={(val) => <div className="flex align-items-center">
                            <div>{val.DisplayValue}</div>
                        </div>} />
                </div>
            )
        };

        configConfirms.push(
            <p className="line-height-3 p-0 m-0">{DisplayKey || key}: {workflowConfigValues[key]}</p>
        )
    })

    // console.log(workflowConfigValues);

    return (
        <div className="surface-ground px-4 py-8 md:px-6 lg:px-8">
            <div hidden={!success} className="flex align-items-start p-4 bg-green-100 border-round border-1 border-green-300 fixed z-3">
                    <i className="pi pi-check-circle text-green-900 text-2xl mr-3"></i>
                    <div className="mr-3">
                        <div className="text-green-900 font-medium text-xl mb-2 line-height-1">Success</div>
                        <p className="m-0 p-0 text-green-700 line-height-3">Your workflow has been created and is currently being executed.</p>
                    </div>
                    <div className="ml-auto">
                        <a className="inline-flex align-items-center justify-content-center ml-auto border-circle hover:bg-green-50 no-underline cursor-pointer transition-colors transition-duration-150" style={{ width: '1.5rem', height: '1.5rem' }} onClick={() => setSuccess(false)}>
                            <i className="pi pi-times text-green-900"></i>
                        </a>
                    </div>
                </div>
            <div className="text-900 font-medium text-900 text-xl mb-3">Workflow Settings</div>
            <div className="surface-card p-4 shadow-2 border-round">
                <div className="grid formgrid p-fluid">
                    <div className="field mb-4 col-12">
                        <label htmlFor="name" className="font-medium text-900">Workflow Name</label>
                        <InputText id="name" type="text" value={workflowName} onChange={e => setWorkflowName(e.target.value)}/>
                    </div>
                    <div className="field mb-4 col-12 md:col-6">
                        <label htmlFor="definition" className="font-medium text-900">Workflow Definition</label>
                        <Dropdown inputId="definition" options={definitions} value={selectedDefinition} onChange={(e) => setSelectedDefinition(e.value)} optionLabel="name" filter filterBy="name" showClear placeholder="Select a Workflow" itemTemplate={(definition) => <div className="flex align-items-center">
                            <div>{definition.name}</div>
                        </div>} />
                    </div>
                    <div className="field mb-4 col-12 md:col-6">
                        <label htmlFor="dataset" className="font-medium text-900">Dataset</label>
                        <Dropdown 
                            inputId="dataset" 
                            value={selectedDataset}
                            options={datasets} 
                            onChange={(e) => setSelectedDataset(e.value)}
                            optionLabel="name"
                            filter 
                            filterBy="name" 
                            showClear 
                            placeholder="Select a Dataset" 
                            itemTemplate={(dataset) => <div className="flex align-items-center"><div>{dataset.name}: {dataset.id}</div></div>} 
                        />
                    </div>
                    {/* <div className="field mb-4 col-12 md:col-6">
                        <label htmlFor="environment" className="font-medium text-900">Environment</label>
                        <Dropdown inputId="environment" options={environments} value={executionEnvironment} onChange={(e) => setExecutionEnvironment(e.value)} optionLabel="name" filter filterBy="name" showClear placeholder="Select an Environment" itemTemplate={(dataset) => <div className="flex align-items-center">
                            <div>{dataset.name}</div>
                        </div>} />
                    </div> */}
                    {configInputs}
                    <div className="col-12">
                    <Button label="Create Workflow" onClick={() => testAggregate()} className="w-auto mt-3" disabled={!selectedDataset || !selectedDefinition || !workflowName}/>
                    <Dialog visible={aggregateError.visible} header={
                        <div className="flex align-items-center">
                            <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle" style={{ width: '32px', height: '32px' }}>
                                <i className="pi pi-info text-lg"></i>
                            </span>
                            <span className="font-medium text-2xl text-900">Dataset Error</span>
                        </div>
                    } 
                    onHide={() => setAggregateError({visible: false, messages: []})}
                    footer={
                        <div className=" border-top-1 surface-border pt-3">
                            <Button icon="pi pi-times" onClick={() => setAggregateError({visible: false, messages: []})} label="Cancel" className="p-button-text" />
                        </div >
                    } modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }}>
                        {aggregateError.messages.map(message => {
                            return <p>{message}</p>
                        })}
                    </Dialog>
                    <Dialog visible={visible1} header={
                        <div className="flex align-items-center">
                            <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle" style={{ width: '32px', height: '32px' }}>
                                <i className="pi pi-info text-lg"></i>
                            </span>
                            <span className="font-medium text-2xl text-900">Confirm Workflow Details</span>
                        </div>
                    } 
                    onHide={() => setVisible1(false)}
                    footer={
                        <div className=" border-top-1 surface-border pt-3">
                            <Button icon="pi pi-times" onClick={() => setVisible1(false)} label="Cancel" className="p-button-text" />
                            <Button icon="pi pi-send" onClick={() => {setVisible1(false); executeWorkflow()}} label="Execute Workflow" />
                        </div >
                    } modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }}>
                        <div>
                            <p className="line-height-3 p-0 m-0">Name: {workflowName}</p>
                            <p className="line-height-3 p-0 m-0">Definition: {selectedDefinition && selectedDefinition.name}</p>
                            <p className="line-height-3 p-0 m-0">Dataset: {selectedDataset && selectedDataset.name}</p>
                            {configConfirms}
                        </div>
                    </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )
}